import _ from 'lodash';

const arePassengerCountsEqual = (stateroomsA, stateroomsB) => {
  const getTotalPassengerCounts = (staterooms) => ({
    adults: _.sumBy(staterooms, 'adults'),
    seniors: _.sumBy(staterooms, 'seniors'),
    children: _.sumBy(staterooms, 'children.length'),
    lapInfants: _.sumBy(staterooms, 'lapInfants'),
    seatInfants: _.sumBy(staterooms, 'seatInfants'),
  });

  const countsA = getTotalPassengerCounts(stateroomsA || []);
  const countsB = getTotalPassengerCounts(stateroomsB || []);

  return _.isEqual(countsA, countsB);
};

export default arePassengerCountsEqual;
